<div class="discount spacing--padding-all spacing--margin-all" data-test="discount">
  <h6 class="text--h6">{{ 'settings.discount.label' | translate }}</h6>
  <form [formGroup]="form" (ngSubmit)="save()">
    <div class="flex--column">
      <mat-form-field class="flex__child--auto">
        <span matTextPrefix class="spacing--padding-half-right">{{ currency }}</span>
        <mat-label>{{ 'settings.discount.bulk' | translate }}</mat-label>
        <input matInput agrNumber [step]="0.01" data-test="discount__bulk" formControlName="bulk" />
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <span matTextPrefix class="spacing--padding-half-right">{{ currency }}</span>
        <mat-label>{{ 'settings.discount.purchase' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          data-test="discount__purchase"
          formControlName="purchase"
        />
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <span matTextPrefix class="spacing--padding-half-right">{{ currency }}</span>
        <mat-label>{{ 'settings.discount.deliveryday' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          data-test="discount__deliveryday"
          formControlName="deliveryday"
        />
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <span matTextPrefix class="spacing--padding-half-right">%</span>
        <mat-label>{{ 'settings.discount.payment' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          data-test="discount__payment"
          formControlName="payment"
        />
        <mat-error *ngIf="!!form.controls.payment.errors && form.controls.payment.errors.min">
          {{ 'settings.discount.invalid.min' | translate }}
        </mat-error>
        <mat-error *ngIf="!!form.controls.payment.errors && form.controls.payment.errors.max">
          {{ 'settings.discount.invalid.max' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <span matTextPrefix class="spacing--padding-half-right">%</span>
        <mat-label>{{ 'settings.discount.member-benefit' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          data-test="discount__member-benefit"
          formControlName="memberBenefit"
        />
        <mat-error
          *ngIf="!!form.controls.memberBenefit.errors && form.controls.memberBenefit.errors.min"
        >
          {{ 'settings.discount.invalid.min' | translate }}
        </mat-error>
        <mat-error
          *ngIf="!!form.controls.memberBenefit.errors && form.controls.memberBenefit.errors.max"
        >
          {{ 'settings.discount.invalid.max' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-form-field class="flex__child--auto">
        <span matTextPrefix class="spacing--padding-half-right">{{ currency }}</span>
        <mat-label>{{ 'settings.discount.member-discount' | translate }}</mat-label>
        <input
          matInput
          agrNumber
          [step]="0.01"
          data-test="discount__member-discount"
          formControlName="memberDiscount"
        />
      </mat-form-field>
    </div>

    <div class="mat-button-row spacing--padding-top">
      <button
        type="submit"
        mat-flat-button
        class="flex__child"
        color="primary"
        data-test="discount__save"
      >
        {{ 'save' | translate }}
      </button>
    </div>
  </form>
</div>
